const typography = {
  fontFamily: "'Plus Jakarta Sans', sans-serif",
  h1: {
    fontWeight: 800, // Bolder
    fontSize: '2.25rem',
    lineHeight: 1.2,
    letterSpacing: '-0.02em',
  },
  h2: {
    fontWeight: 700,
    fontSize: '1.875rem',
    lineHeight: 1.3,
    letterSpacing: '-0.01em',
  },
  h3: {
    fontWeight: 700,
    fontSize: '1.5rem',
    lineHeight: 1.4,
    letterSpacing: '0em',
  },
  h4: {
    fontWeight: 600,
    fontSize: '1.25rem',
    lineHeight: 1.4,
  },
  h5: {
    fontWeight: 600,
    fontSize: '1.125rem',
    lineHeight: 1.5,
  },
  h6: {
    fontWeight: 600,
    fontSize: '1rem',
    lineHeight: 1.5,
  },
  button: {
    textTransform: 'none',
    fontWeight: 700,
    letterSpacing: '0.02em',
  },
  body1: {
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: 1.65, // Relaxed reading
    color: 'text.primary',
  },
  body2: {
    fontSize: '0.875rem',
    letterSpacing: '0em',
    fontWeight: 400,
    lineHeight: 1.6,
    color: 'text.secondary',
  },
  subtitle1: {
    fontSize: '1rem',
    fontWeight: 600,
    letterSpacing: '0em',
  },
  subtitle2: {
    fontSize: '0.875rem',
    fontWeight: 600,
    letterSpacing: '0em',
  },
  caption: {
    fontSize: '0.75rem',
    fontWeight: 500,
    lineHeight: 1.5,
    color: 'text.secondary',
  },
};

export default typography;
